import { render, staticRenderFns } from "./AstaEditSquadra.vue?vue&type=template&id=2fcef0fc&scoped=true&"
import script from "./AstaEditSquadra.vue?vue&type=script&lang=js&"
export * from "./AstaEditSquadra.vue?vue&type=script&lang=js&"
import style0 from "./AstaEditSquadra.vue?vue&type=style&index=0&id=2fcef0fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcef0fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fcef0fc')) {
      api.createRecord('2fcef0fc', component.options)
    } else {
      api.reload('2fcef0fc', component.options)
    }
    module.hot.accept("./AstaEditSquadra.vue?vue&type=template&id=2fcef0fc&scoped=true&", function () {
      api.rerender('2fcef0fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/AstaEditSquadra.vue"
export default component.exports